export default __webpack_public_path__ + "static/media/163a06ed751766.376b4c85.png";